'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

let moduleName = 'appFilters';

angular.module(moduleName, [])
    .filter('nospace',require('./filters/nospace'))
    .filter('raw', ['$sce', require('./filters/raw')])
    .filter('humanizeDoc', require('./filters/humanize_doc'));


exports.default = moduleName;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./js/filters.js
 **/